
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Pancreatic_endocrine_tumor",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Pancreatic_endocrine_tumor.vue